module.exports = __webpack_public_path__ + "img/فنریی2.bdaf22d0.png";